import type { DmPrinter } from '@nsftx/systems-sdk'
import { logService } from '@nsftx/seven-client-retail-utils'
import { useDeviceManagementPrintStore } from '#src/main'

const LOG_PREFIX = '[printUtilsService]'

const isDmPrinter = (printer?: DmPrinter | null): printer is DmPrinter =>
  Boolean(
    (printer as DmPrinter)?.id && (printer as DmPrinter)?.model && (printer as DmPrinter)?.queueName
  )

const getResolvedPrinter = (printer?: DmPrinter | null) => {
  const selectedPrinter = isDmPrinter(printer) && printer
  const { detectedPrinters } = useDeviceManagementPrintStore()

  if (!selectedPrinter) {
    logService.info(`${LOG_PREFIX} Selected printer is unknown, first detected printer is set,`, {
      code: 'DM_PRINT_SELECTED_PRINTER_UNKNOWN',
      details: {
        printer
      }
    })
    return detectedPrinters[0]?.printer
  }

  const isSelectedPrinterFound = detectedPrinters.some(
    ({ printer }) => printer.id === selectedPrinter.id
  )
  if (isSelectedPrinterFound) {
    return selectedPrinter
  }

  logService.info(
    `${LOG_PREFIX} Selected printer not found in detected printers, first detected printer is set`,
    {
      printer: selectedPrinter,
      code: 'DM_PRINT_SELECTED_PRINTER_NOT_FOUND'
    }
  )

  return detectedPrinters[0]?.printer
}

export { isDmPrinter, getResolvedPrinter }
